import { productConfig } from '../../../config';
import { http } from '../../../api/axios';
import { ProductMetaData } from '../../../../models/Product';

export const fetchBackIssues = async (productId: string) => {
    const { data } = await http.get<{ hits: ReadonlyArray<ProductMetaData>; totalHits: number }>(
        productConfig().endpointBackIssues,
        {
            params: { limit: 20 },
            pathParams: { productId }
        }
    );
    return data;
};
